import { useTestResourceApi } from "../api/TestResourceApiClient";
import { TestResourceFrontendService } from "../services/TestResourceFrontendService";

export const useTestResourceService = (): TestResourceFrontendService =>
  new TestResourceFrontendService(useTestResourceApi());
